import { render } from "./notifications-settings.vue?vue&type=template&id=62e81048"
import script from "./notifications-settings.vue?vue&type=script&lang=js"
export * from "./notifications-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__